import { useState, useEffect,useRef } from "react";
import React from 'react';
import ReactDatetime from "react-datetime";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  PopoverBody,
  UncontrolledPopover,
   InputGroupAddon ,
  InputGroupText  
} from "reactstrap";
import { AgGridReact, AllCommunityModules, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { userService } from "../../../services/authentication";
import { reportmanageService } from "../../../services/reportmanageService";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { forEachChild } from "typescript";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import Navbuttons from "components/Navigations/Navbuttons.js";
import { stringToArray } from "ag-grid-community";
const axios = require("axios");
import { apiUrl } from "../../../constant";
import { authtoken } from "global.js";
import {Formloader} from 'components/Loader/PageLoader.js';
import Paginationcomponent from "components/Paginationcomponent.js"
import {taskmanageService} from '../../../services/taskmanageService';
import { usermanageService } from "../../../services/usermanageService";
import { clientmanageService } from "../../../services/clientmanageService.js";
import Select from 'react-select';

const TurnOverReport = (props) => {
    const [state, setState] = useState({startDate:'',endDate:''});
  const [filtertype,setfiltertype] = useState('total');
  const [dashboarddata, setDashboarddata] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [total_page,setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const regionOption = useRef(null)
  
  const handlePageClick = (e, index) => {
 
    e.preventDefault();
    get_list(index,null,filtertype,rowsPerPage);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev,null,filtertype,rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next,null,filtertype,rowsPerPage);
  };
  const handleRowsPerPageChange = (newRowsPerPage) => {

    setRowsPerPage(newRowsPerPage);
    
    setCurrentPage(1); 
    get_list(1,null,filtertype,newRowsPerPage)
  
  };
  const get_list = async (pageNumber = 1,e,filtertype='',rowsPerPage='',client='',start_date='',end_date='') => {
    let  textbox = '';

    if(e != null){
       textbox = e.target.value;
    }
   
    reportmanageService.getturnoverReport(pageNumber,textbox,filtertype,rowsPerPage,client,start_date,end_date).then((response) => {
     console.log(response.data.data)
      setDashboarddata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setTotalData(response.data.data.total);
    });
  };
  function filterallcom({type}){
    setfiltertype(type)
    get_list(1,null,type);
 }

 useEffect(() => {
  getPhases();
  // get_dashboard_data();
   get_list(1,null,filtertype);
   get_unique_companieslist();
  
}, []);
  const [clientsearch, setclientsearch] = useState([{'label':'All Clients',value:'al_key_1'}]);
  function setclient(e){ 
    setclientsearch(e.label);
    regionOption.current.setValue('');
    subclientList(e.label)
    //setClientdata([]);
    
    // var index = e.target.selectedIndex;
    // setclientsearch(e.target[index].text)
   
    
    
  }
  const[phaselist,setPhaseList]=useState([]);
  function getPhases(){
    usermanageService.getphasesfulllist().then((response)=>{
      if (response.status == 200) {

        setPhaseList(response.data.phases)
      }
    })
  }
  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  function get_unique_companieslist(){
    clientmanageService.getuniquecompaniessearchable().then((response)=>{
      setUniqueCompaniesData(response.data);
    });
  }
  const [ subclientlist, setsubclientlist ] = useState([{'label':'Select Sub Client',value:''}])
  
    function subclientList(clientname=''){
      //setsubclientlist([]);
      clientmanageService.getsubclientlistsearchable(clientname).then((response) => {
          if(response.status === 200){
            setsubclientlist(response.data)
          }else {
            toast.error('Something went wrong!');
          }
      });
    }
    const [sub_client, setSub_client] = useState('');
  const companyfilter = (e,index) => {
 get_list(1,null,filtertype,rowsPerPage,e.value);
 //setAllclient(false)
  setSub_client(e.value)
};
  function setEndDateRange(e){
    var month = e._d.getMonth() + 1;
    var date = e._d.getDate();
    var year = e._d.getFullYear();
    var dd = date + '-' + month + '-' + year;
    
    setState({ ...state,endDate: e });
   
    get_list(1,null,filtertype,rowsPerPage,sub_client,state.startDate, dd);
  }
  function setStartDateRange(e){
    var month = e._d.getMonth() + 1;
    var date = e._d.getDate();
    var year = e._d.getFullYear();
    var dd = date + '-' + month + '-' + year;
    setState({ ...state, startDate: dd })
    
  }
  return (
    <>
    <Header />
     <Container className="mt--7" fluid>
        <Row>
        <Col>
         <h2>Turnover Report</h2>
            
         
          </Col>
           
        </Row>

          
         
            <div className="col" style={{padding:'0%'}}>
              <Card className="shadow">
              <CardHeader>
                  <div className="filter">
                  
                    <div   style={{maxWidth:'100%'}} className="d-flex">
                    {/* <Button
                      className="btn-icon-clipboard"
                      type="button"
                      onClick={downloadReport}
                      style={{textAlign:'center'}}
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                    </Button> */}
                    {/* <select
        id="year"
        name="year"
        value={selectedYear}
        onChange={handleYearChange}
        className="form-control"
        
      >
        <option value="">Select Year</option>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select> */}

                         <div className="col-xl-3 col-md-3 col-xs-12">
                         <h3 className="clientformtag"> Client</h3>
                              {(uniquecompanieslist.length > 0 )?
                              <Select 
                             
                              className="input-group-alternative mb-3" 
                              name="user_id"
                              options={uniquecompanieslist} // set list of the data
                              onChange={(e) => { setclient(e)}}
                             
                              searchable
                              isClearable={false}
                            />
                                   
                                  : null }
                              </div>
                              <div className="col-xl-3 col-md-3 col-xs-12">
                               <h3 className="clientformtag">Sub Client</h3>
                                  <Select 
                                  ref={regionOption}
                                  className="input-group-alternative mb-3" 
                                  name="sub_client"
                                  options={subclientlist} // set list of the data
                                  onChange={(e) => companyfilter(e,9)}
                                  defaultValue={subclientlist}
                                  searchable
                                  isClearable={true}
                                  />
                                  
                              </div>
                            <div className="col-4">
                    <label>Start Date</label>
                      <FormGroup>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <ReactDatetime
                            inputProps={{
                              placeholder: "Start date"
                            }}
                            timeFormat={false}
                            renderDay={(props, currentDate, selectedDate) => {
                              let classes = props.className;
                              if (
                                state.startDate &&
                                state.endDate &&
                                state.startDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " start-date";
                              } else if (
                                state.startDate &&
                                state.endDate &&
                                new Date(state.startDate._d + "") <
                                  new Date(currentDate._d + "") &&
                                new Date(state.endDate._d + "") >
                                  new Date(currentDate._d + "")
                              ) {
                                classes += " middle-date";
                              } else if (
                                state.endDate &&
                                state.endDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " end-date";
                              }
                              return (
                                <td {...props} className={classes}>
                                  {currentDate.date()}
                                </td>
                              );
                            }}
                            onChange={e => setStartDateRange(e)}
                          />
                        </InputGroup>
                      </FormGroup>
                    </div>
                    <div className="col-4">
                      <label>End Date</label>
                      <FormGroup>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <ReactDatetime
                            inputProps={{
                              placeholder: "End date"
                            }}
                            timeFormat={false}
                            renderDay={(props, currentDate, selectedDate) => {
                              let classes = props.className;
                              if (
                                state.startDate &&
                                state.endDate &&
                                state.startDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " start-date";
                              } else if (
                                state.startDate &&
                                state.endDate &&
                                new Date(state.startDate._d + "") <
                                  new Date(currentDate._d + "") &&
                                new Date(state.endDate._d + "") >
                                  new Date(currentDate._d + "")
                              ) {
                                classes += " middle-date";
                              } else if (
                                state.endDate &&
                                state.endDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " end-date";
                              }
                              return (
                                <td {...props} className={classes}>
                                  {currentDate.date()}
                                </td>
                              );
                            }}
                            onChange={e => setEndDateRange(e)}
                          />
                        </InputGroup>
                      </FormGroup>
                    </div >
                    </div></div>
              </CardHeader>
              <Table className="align-items-center table-flush"   responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className="whitespace sortclass" >Client</th>
                    <th scope="col">Sub CLient</th>
                    {phaselist.map(phase=>{
                      return <th>{phase.desc}</th>
                    })}
                    
                    
                    
                  </tr>
                </thead>
               <tbody>
               {dashboarddata.length > 0 ? (
  dashboarddata.map((item, i) => (
    <React.Fragment key={i}>
      <tr className={i % 2 === 0 ? 'blue-row' : (i % 3 === 0 ? 'purple-row' : 'orange-row')}>
        <td className="text-left">{item.name}</td>
        <td className="text-left">{item.sub_client}</td>
        
        
        {phaselist.map((phase, phaseIndex) => {
          
          const phaseValue = item[phase.desc];
          
          return (
            <td key={phaseIndex}>
              {phaseValue !== null  ? phaseValue : ''}
            </td>
          );
        })}
      </tr>
    </React.Fragment>
  ))
) : (
  <tr>
    <td colSpan="10">No Data Found</td>
  </tr>
)}

               </tbody>
              </Table>
              <CardFooter className="py-4">
              <div>
     
              <Paginationcomponent
        currentPage={currentPage}
        totalItems={total_page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        handlePageClick={handlePageClick}
        handlePreviousClick={handlePreviousClick}
        handleNextClick={handleNextClick}
        handleRowsPerPageChange={handleRowsPerPageChange}
      />
                </div>
              </CardFooter>
              </Card>
            </div>
            
          
       
     </Container>
    </>
  );
};


export default TurnOverReport;
